const mutations = {
  setModels(state, data) {
    state.periodoInscripciones = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.periodoInscripcion = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.periodoInscripciones.unshift(model);
  },

  updateModel(state, model) {
    state.periodoInscripcion = model;
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.periodoInscripciones
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.periodoInscripciones.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
